import React, { useState, useEffect } from 'react';
  
  const Controls = () =>  {

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    
    useEffect(() => {
        
        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Check if the device is mobile or tablet
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1024;

	return (
	    <div id="controls" style={{padding: '3rem 1rem 0', marginLeft: 'auto', marginRight: 'auto', maxWidth: '1280px', width: '100%'}}>
            {/* Section Header */}
            <div style={{textAlign: 'center', marginBottom: '2rem'}}>
                {/* Title - Header */}
                <h2 style={{fontSize: `${isMobile ? '2.25rem' : '3rem'}`, fontWeight: 'bold', marginBottom: '1rem'}}>
                    Keyboard Controls
                </h2>
                {/* Description - Header */}
                <p style={{fontSize: '1.125rem', lineHeight: '1.75rem', color: 'rgb(153,153,153)', fontWeight: 500}}>
                    These commands are designed to be natural and easy to remember.
                </p>
            </div>
            {/* Block Grid */}
            <div style={{display: 'grid', gridTemplateColumns: `${isTablet ? `${isMobile ? 'repeat(1,minmax(0,1fr))' : 'repeat(2,minmax(0,1fr))'}` : 'repeat(3,minmax(0,1fr))'}`, gap: '1rem', padding: '2.5rem 0'}}>
                {/* Block */}
                <div style={{padding: '1rem', width: '100%', height: '100%', border: '1px solid rgb(39, 39, 42)', borderRadius: '1rem', overflow: 'hidden'}}>
                    <h3 style={{fontSize: '1.125rem', margin: '0 0 .75rem'}}>
                        Hide/Show Window
                    </h3>
                    <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '1rem', gap: '.5rem'}}>
                        <span style={{fontSize: '1.5rem', color: 'rgb(161, 161, 170)', fontWeight: 'bold', padding: '.5rem .875rem', background: 'rgb(39, 39, 42)', borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '50px'}}>
                            Ctrl
                        </span>
                        <span style={{fontSize: '1.5rem', color: 'rgb(161, 161, 170)', fontWeight: 'bold', padding: '.5rem .875rem', background: 'rgb(39, 39, 42)', borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '50px'}}>
                            B
                        </span>
                    </div>
                    <div style={{color: 'rgb(161, 161, 170)', fontSize: '.875rem', fontWeight: 500, lineHeight: '1.25rem', marginTop: '2rem'}}>
                        Hide/show the Interview Cheater window instantly.
                    </div>
                </div>
                {/* Block */}
                <div style={{padding: '1rem', width: '100%', height: '100%', border: '1px solid rgb(39, 39, 42)', borderRadius: '1rem', overflow: 'hidden'}}>
                    <h3 style={{fontSize: '1.125rem', margin: '0 0 .75rem'}}>
                        Take Screenshot
                    </h3>
                    <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '1rem', gap: '.5rem'}}>
                        <span style={{fontSize: '1.5rem', color: 'rgb(161, 161, 170)', fontWeight: 'bold', padding: '.5rem .875rem', background: 'rgb(39, 39, 42)', borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '50px'}}>
                            Ctrl
                        </span>
                        <span style={{fontSize: '1.5rem', color: 'rgb(161, 161, 170)', fontWeight: 'bold', padding: '.5rem .875rem', background: 'rgb(39, 39, 42)', borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '50px'}}>
                            H
                        </span>
                    </div>
                    <div style={{color: 'rgb(161, 161, 170)', fontSize: '.875rem', lineHeight: '1.25rem', marginTop: '2rem'}}>
                        <div style={{display: 'flex'}}>
                            <span style={{color: '#FFFF00', fontSize: '.75rem', marginTop: '.125rem', marginRight: '.5rem'}}>
                            •
                            </span>
                            <span style={{color: 'rgb(161, 161, 170)', fontSize: '.875rem', lineHeight: '1.25rem'}}>
                                <span style={{fontWeight: 'bold'}}>Problem Mode:</span> Capture screenshots of the interview question and requirements.
                            </span>
                        </div>
                        <div style={{display: 'flex', marginTop: '1rem'}}>
                            <span style={{color: '#FFFF00', fontSize: '.75rem', marginTop: '.125rem', marginRight: '.5rem'}}>
                            •
                            </span>
                            <span style={{color: 'rgb(161, 161, 170)', fontSize: '.875rem', lineHeight: '1.25rem'}}>
                                <span style={{fontWeight: 'bold'}}>Solution Mode:</span> Take screenshots of a follow up question or new requirements.
                            </span>
                        </div>
                    </div>
                </div>

                {/* Block */}
                <div style={{padding: '1rem', width: '100%', height: '100%', border: '1px solid rgb(39, 39, 42)', borderRadius: '1rem', overflow: 'hidden'}}>
                    <h3 style={{fontSize: '1.125rem', margin: '0 0 .75rem'}}>
                        Generate Solution
                    </h3>
                    <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '1rem', gap: '.5rem'}}>
                        <span style={{fontSize: '1.5rem', color: 'rgb(161, 161, 170)', fontWeight: 'bold', padding: '.5rem .875rem', background: 'rgb(39, 39, 42)', borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '50px'}}>
                            Ctrl
                        </span>
                        <span style={{fontSize: '1.5rem', color: 'rgb(161, 161, 170)', fontWeight: 'bold', padding: '.5rem .875rem', background: 'rgb(39, 39, 42)', borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '50px'}}>
                            ENTER
                        </span>
                    </div>
                    <div style={{color: 'rgb(161, 161, 170)', fontSize: '.875rem', lineHeight: '1.25rem', marginTop: '2rem'}}>
                        <div style={{display: 'flex'}}>
                            <span style={{color: '#FFFF00', fontSize: '.75rem', marginTop: '.125rem', marginRight: '.5rem'}}>
                            •
                            </span>
                            <span style={{color: 'rgb(161, 161, 170)', fontSize: '.875rem', lineHeight: '1.25rem'}}>
                                <span style={{fontWeight: 'bold'}}>Problem Mode:</span> Generate an initial solution with detailed explanations based on the problem screenshots.
                            </span>
                        </div>
                        <div style={{display: 'flex', marginTop: '1rem'}}>
                            <span style={{color: '#FFFF00', fontSize: '.75rem', marginTop: '.125rem', marginRight: '.5rem'}}>
                            •
                            </span>
                            <span style={{color: 'rgb(161, 161, 170)', fontSize: '.875rem', lineHeight: '1.25rem'}}>
                                <span style={{fontWeight: 'bold'}}>Solution Mode:</span> Debug and optimize your existing solution based on existing solution and new screenshots.
                            </span>
                        </div>
                    </div>
                </div>

                {/* Block */}
                <div style={{padding: '1rem', width: '100%', height: '100%', border: '1px solid rgb(39, 39, 42)', borderRadius: '1rem', overflow: 'hidden'}}>
                    <h3 style={{fontSize: '1.125rem', margin: '0 0 .75rem'}}>
                        Move Window
                    </h3>
                    <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '1rem', gap: '.5rem'}}>
                        <span style={{fontSize: '1.5rem', color: 'rgb(161, 161, 170)', fontWeight: 'bold', padding: '.5rem .875rem', background: 'rgb(39, 39, 42)', borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '50px'}}>
                            Ctrl
                        </span>
                        <span style={{fontSize: '1.5rem', color: 'rgb(161, 161, 170)', fontWeight: 'bold', padding: '.5rem .875rem', background: 'rgb(39, 39, 42)', borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '50px'}}>
                            ↑↓←→
                        </span>
                    </div>
                    <div style={{color: 'rgb(161, 161, 170)', fontSize: '.875rem', fontWeight: 500, lineHeight: '1.25rem', marginTop: '2rem'}}>
                        Move the window around your screen without touching the mouse.
                    </div>
                </div>

                {/* Block */}
                <div style={{padding: '1rem', width: '100%', height: '100%', minHeight: '300px', border: '1px solid rgb(39, 39, 42)', borderRadius: '1rem', overflow: 'hidden'}}>
                    <h3 style={{fontSize: '1.125rem', margin: '0 0 .75rem'}}>
                        Reset Problem
                    </h3>
                    <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '1rem', gap: '.5rem'}}>
                        <span style={{fontSize: '1.5rem', color: 'rgb(161, 161, 170)', fontWeight: 'bold', padding: '.5rem .875rem', background: 'rgb(39, 39, 42)', borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '50px'}}>
                            Ctrl
                        </span>
                        <span style={{fontSize: '1.5rem', color: 'rgb(161, 161, 170)', fontWeight: 'bold', padding: '.5rem .875rem', background: 'rgb(39, 39, 42)', borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '50px'}}>
                            R
                        </span>
                    </div>
                    <div style={{color: 'rgb(161, 161, 170)', fontSize: '.875rem', fontWeight: 500, lineHeight: '1.25rem', marginTop: '2rem'}}>
                        Reset everything to start fresh with a new problem.
                    </div>
                </div>

                {/* Block */}
                <div style={{padding: '1rem', width: '100%', height: '100%', border: '1px solid rgb(39, 39, 42)', borderRadius: '1rem', overflow: 'hidden'}}>
                    <h3 style={{fontSize: '1.125rem', margin: '0 0 .75rem'}}>
                        Quit Application
                    </h3>
                    <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', marginTop: '1rem', gap: '.5rem'}}>
                        <span style={{fontSize: '1.5rem', color: 'rgb(161, 161, 170)', fontWeight: 'bold', padding: '.5rem .875rem', background: 'rgb(39, 39, 42)', borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '50px'}}>
                            CTRL
                        </span>
                        <span style={{fontSize: '1.5rem', color: 'rgb(161, 161, 170)', fontWeight: 'bold', padding: '.5rem .875rem', background: 'rgb(39, 39, 42)', borderRadius: '1rem', display: 'flex', justifyContent: 'center', alignItems: 'center', minWidth: '50px'}}>
                            Q
                        </span>
                    </div>
                    <div style={{color: 'rgb(161, 161, 170)', fontSize: '.875rem', fontWeight: 500, lineHeight: '1.25rem', marginTop: '2rem'}}>
                        Quit the application to remove the functionality of all keyboard commands.
                    </div>
                </div>
            </div>
        </div>
	);
  }
  
  export default Controls;
  